/*
 * @Descripttion:
 * @version:
 * @Author: LeBeryl
 * @Date: 2021-03-29 14:14:07
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-09-07 16:56:37
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '../store/index.js'
Vue.use(VueI18n)
const i18n = new VueI18n({
  // locale: 'zhCHT',
  locale: store.globalData.lang || 'zhEn',
  messages: {
    zhCHT: require('./langs/zhCHT'),
    zhEn: require('./langs/zhEn')
  }
})
export default i18n
